import './styles.sass';

import React from 'react';
import Transition from 'components/Explorer/Transition';
import { Link } from 'react-router-dom';

import NewsHighlight from './NewsHighlight';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const jumpLocationFor = (params) => {
  const filters = { ...(params.filters || {}), highlights: true };
  return QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');
};

const NewsHighlights = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/news_highlights', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = Array.isArray(data) && data.length > 0;

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-NewsHighlights-content">
        {hasResults ? (
          data.map((highlight) => <NewsHighlight key={`${highlight.id}-highlight`} highlight={highlight} />)
        ) : (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.NewsHighlights.empty')}</div>
        )}
      </div>
    );
  };

  return (
    <div className="Highlights-NewsHighlights Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.NewsHighlights.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>
          {isLoading ? <div key="loadingMessage" className="Highlights-loading-message" /> : content()}
        </Transition>
        {hasResults && (
          <Link
            onClick={() => Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'news-highlights' })}
            to={jumpLocationFor(params)}
            className="Highlights-jump-link"
            aria-label={
              I18n.t('Explorer.Highlights.NewsHighlights.title') +
              ' — ' +
              I18n.t('Explorer.Highlights.NewsHighlights.more')
            }
          >
            {I18n.t('Explorer.Highlights.NewsHighlights.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default NewsHighlights;
